import { render } from "./IconExit.vue?vue&type=template&id=5baafaab"
import script from "./IconExit.vue?vue&type=script&lang=js"
export * from "./IconExit.vue?vue&type=script&lang=js"
script.render = render

export default script